// import gsap from 'gsap'
import { bp, callAfterResize, mm, onDOMAndFontsReady, preventOrphan, sel, selAll, stResizeObserver, wrapLastTwo } from './utils'
// import { SplitText } from 'gsap/SplitText'
// import SplitType from 'split-type'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(SplitText, ScrollTrigger)

export default function Exec() {
  // return
  window.addEventListener('load', function () {
    document.fonts.load('1rem "DM Sans"').then(() => {
      const isDeskSafari = !!(window.safari && window.safari.pushNotification)
      const ifChromeBlur = !isDeskSafari ? { filter: 'blur(50px)' } : {}
      // window.addEventListener('load', function () {
      //   document.fonts.load('1rem "DM Sans"').then(() => {
      const tW$ = sel('.h1--epic-w')
      // tW$.classList.add('blur-wrap')

      // console.log('Epic.js loaded 27', isDeskSafari)
      // return
      const navbarW$ = sel('.navbar-a')
      const navbar$ = sel('#navbar')

      const hero$ = sel('.hero.is--v2')
      // const heroBg$ = hero$.querySelector('.hero__bg-w--vid')
      // const heroBg$ = hero$.querySelector('.hero__epic-svg')
      const heroTag$ = hero$.querySelector('.hero__tag--epic')
      // const compHsT = new SplitType('.comp-hero__h', { types: 'words, chars' })
      const compHsT = SplitText.create('.h1--epic', { type: 'chars, words' }) // words to keep the initial wrapping
      // const compHsT = new SplitType('.h1--epic', { types: 'chars, words', lineClass: 'st-line' })

      const epicSvgW$ = sel('.epic--hero--img')

      mm.add(bp.tabUp, () => {
        // gsap.to(heroBgImgW$, { rotate: -360, transformOrigin: 'center center', duration: 300, repeat: -1, ease: 'none' })
        const intro$ = sel('.epic-intro-sec')
        const introBg$ = sel('.epic-intro__bg-w')
        const introDim$ = sel('.epic-intro__dim-top')
        const introBlend$ = sel('.epic-intro__dim')
        const introVidBg$ = sel('.epic-intro__vid-bg-w')
        const introH$ = intro$.querySelector('h2')
        const introHsT = SplitText.create(introH$, { type: 'chars, words' })
        gsap.set(intro$, { yPercent: -100, marginBottom: '100vh' })
        // gsap.set(hero$, { marginBottom: '-100vh' })
        gsap.set(introBlend$, { display: 'none' })
        // gsap.set(introVidBg$, { scale: 1.2 })
        const introTl = gsap
          .timeline({ defaults: { ease: 'none', duration: 2 } })
          // .from(introVidBg$, { autoAlpha: 0, ...(!isSafariMac ? { scale: 1.2 } : {}), duration: 7 }, 0)
          .from(introDim$, { autoAlpha: 1, duration: 7 }, 0)
          .from(introVidBg$, { scale: 1.2, duration: 7 }, 0)
          .from(
            introHsT.chars,
            {
              autoAlpha: 0,
              // filter: 'blur(50px)',
              ...ifChromeBlur,
              stagger: {
                each: 0.04,
              },
              duration: 1.5,
            },
            0.5
          )
        // .from(intro$, { yPercent: 100 }, 5)
        // .from(epic$, { yPercent: -100 }, 5)
        // .from(intro$, { marginBottom: '-200vh' }, 5)
        ScrollTrigger.create({
          trigger: hero$,
          start: 'top top+=1',
          end: '300%',
          scrub: true,
          pin: intro$,
          pinSpacing: false,
          animation: introTl,
        })
      })
      // Props sec
      const prop$a = selAll('.epic-props__item')
      prop$a.forEach((prop$) => {
        // console.log(prop$)
        const p$a = prop$.querySelectorAll('.p--epic')
        p$a.forEach((p$) => {
          // gsap.set(p$, { marginBottom: '1.5rem' })
        })
        const pW$ = prop$.querySelector('.p-w--epic')
        // selAll('.p--epic').forEach((p$) => {
        //   wrapLastTwo(p$)
        //   console.log('p$', p$)
        // })
        const pWSt = SplitText.create(pW$, { type: 'words' })
        //
        const propTl = gsap.timeline({ defaults: { duration: 1, ease: 'none' } }).from(pWSt.words, {
          autoAlpha: 0.2,
          stagger: { amount: 5 },
        })
        ScrollTrigger.create({
          trigger: prop$,
          start: 'top bottom',
          // end: (p$a.length - 1) * 200 + '%',
          end: 'bottom 75%',
          scrub: true,
          animation: propTl,
          // markers: true,
        })
      })
      // Test
      console.log('x')
      const epic$ = sel('.epic-props-sec')
      const testW$ = sel('.epic-test-sec-w')
      const test$ = sel('.epic-test-sec')
      const testC$ = sel('.epic-test__c')
      const testA$ = test$?.querySelector('.btn')
      const tableW$ = sel('.epic-table-sec-w')
      const table$ = sel('.epic-table-sec')
      gsap.set(test$, { yPercent: -100 })
      // gsap.set(test$, { marginTop: '-100vh' })
      // gsap.set(test$, { marginTop: '-100vh', marginBottom: '-100vh' })

      const testTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } })
      ScrollTrigger.create({
        trigger: epic$,
        start: 'bottom bottom',
        end: '+=100%',
        // end: '+=200%',
        scrub: true,
        pin: test$,
        pinSpacing: false,
        // animation: testTl,
      })
      async function videoModal() {
        const videoBtn$ = sel('#customPlayerBtn')
        if (!videoBtn$) return

        const sec$ = sel('.epic-test-sec')
        const modW$ = sel('body').appendChild(sec$.querySelector('.mod-w'))

        const close$ = modW$.querySelector('.mod__x-w')
        const mod$ = modW$.querySelector('.mod')
        const bg$ = modW$.querySelector('.mod-bg')
        modW$.classList.add('display-hide')

        const _player = modW$.querySelector('.custom_player.is--test')
        // console.log(_player.getAttribute('src'))
        const src = _player.getAttribute('data-src') || 'youtube/4UgnVc7kRxE'
        const player = await VidstackPlayer.create({
          target: _player,
          src: src,
          // src: 'vimeo/1061484821',
          poster:
            'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/6826898440714274aa9fd120_67575b133690ca3c5bb9254a_test_img1_q85-gigapixel-low%20resolution%20v2-4x%20copy.webp',
          crossOrigin: true,
          playsInline: true,
          viewType: 'video',
          load: 'idle',
          layout: new VidstackPlayerLayout(),
        })

        const tl = gsap
          .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
          .to(
            {},
            {
              onStart: () => {
                modW$.classList.remove('display-hide')
              },
              onReverseComplete: () => {
                modW$.classList.add('display-hide')
              },
              duration: 0.1,
            }
          )
          .to(modW$, { opacity: 1 })
          .from(mod$, { y: 50 }, 0)

        const closeModal = (e) => {
          e?.stopImmediatePropagation()
          tl.reverse()
          player.pause()
        }

        videoBtn$.onclick = (e) => {
          // console.log('pl', player.state.canPlay)
          tl.play()

          if (player.state.canPlay) {
            player.play()
          } else {
            player.addEventListener(
              'can-play',
              (event) => {
                // console.log('canplay')
                player.play()
              },
              { once: true }
            )
          }
        }
        ;[close$, bg$].forEach((el) => {
          el.onclick = closeModal
        })

        player.addEventListener('ended', (event) => {
          closeModal()
        })

        callAfterResize(() => closeModal())
        // console.log('videoBtn$', videoBtn$)
      }
      videoModal()

      mm.add(bp.tabUp, () => {
        // Footer

        const cta$ = sel('.epic-cta-sec')
        const ctaH$ = cta$.querySelector('h2')
        const ctaHsT$ = SplitText.create(ctaH$, { type: 'words, chars' })
        const ctaP$ = cta$.querySelector('.epic-cta__info>div:not(.button-group)')
        const ctaBtnGroup$ = cta$.sel('.button-group')
        const ctaBtn$a = ctaBtnGroup$.selAll('.btn')
        const ctaBgSvg$ = cta$.querySelector('.epic-cta__bg-w.is--svg')
        const ctaBgWebp$ = cta$.querySelector('.epic-cta__bg-w-w.is--webp')
        const footer$ = sel('.footer')
        console.log(ctaBgSvg$, ctaBgWebp$)
        if (isDeskSafari) {
          ctaBgSvg$.style.display = 'none'
          ctaBgWebp$.style.display = 'block'
        }
        const ctaTl = gsap
          .timeline({ defaults: { ease: 'power3.out', duration: 1 } })
          //
          .from(
            ctaHsT$.chars,
            {
              autoAlpha: 0,
              // filter: 'blur(50px)',
              ...ifChromeBlur,
              stagger: 0.03,
              ease: 'none',
            },
            0
          )
          .from(ctaP$, { autoAlpha: 0, y: -20 }, '<50%')
          .from(ctaBtn$a, { autoAlpha: 0, y: -20 }, '<10%')
          .from(footer$, { y: 20, autoAlpha: 0, duration: 3 }, '<10%')

        ScrollTrigger.create({
          trigger: cta$,
          start: 'top 80%',
          // end: '+=100%',
          // scrub: true,
          animation: ctaTl,
          toggleActions: 'play none none reverse',
        })
      })
    })
    // stResizeObserver()
  })
}
